// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3Zbkg","thumb":"thumb-15NFc","detailsContainer":"detailsContainer-1Xu0z","name":"name-U61Ks","city":"city-OZR2y","thumbDetail":"thumbDetail-qGyyV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/home/friends/_friend.css
// module id = 1214
// module chunks = 1